import { AfterContentInit, ChangeDetectionStrategy, Component, ContentChild, ElementRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NOT_AVAILABLE } from '../../common/constants/template.constant';
import { TRANSPORT_MODE_ICONS_MAP, TransportMode } from '../../common/constants/transport-mode';
import { PipesModule } from '../../common/pipes/pipes.module';
import { MaterialModule } from '../../material.module';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-transport-mode',
  imports: [CommonModule, TranslateModule, PipesModule, MaterialModule, SvgIconComponent],
  templateUrl: './transport-mode.component.html',
  styleUrls: ['./transport-mode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransportModeComponent implements AfterContentInit {
  @Input() mode: TransportMode;
  @Input() showText = true;
  @Input() isNoteAvailableTitleVisible = true;
  @ContentChild('notAvailableTemplate', { static: false }) content!: ElementRef | undefined;

  transportMode = TransportMode;
  iconsMap = TRANSPORT_MODE_ICONS_MAP;
  notAvailable = NOT_AVAILABLE;
  hasProjectedContent = false;

  ngAfterContentInit(): void {
    this.hasProjectedContent = !!this.content;
  }
}
